import React from "react";
import { Link } from "react-router-dom";
import {useLocation} from "react-router-dom";
import {useEffect , useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {Panel, Steps} from "rsuite";
import PersonalInfos from "./AfterRegistration/1PersonalInfos";
import EducationLevel from "./AfterRegistration/2EducationLevel";
import Comment from "./AfterRegistration/5Comment";
import AbonnementPic from '../images/Siamois/images/happy_people.png'
import {BarChartRounded, BookRounded, BorderColorRounded} from "@mui/icons-material";
import './Home.css'
import {useHistory} from "react-router";


// import Ext from "../../layouts/Ext";

const Home = () => {
    const history = useHistory();
    const location = useLocation();
    const [isRegistrationModalOpen , setRegistrationModalStatus]= useState(false);
    const [isAbonnementModalOpen , setAbonnementModalStatus]= useState(false);

    const [stepRegistration, setStepRegistration] = React.useState(0);
    const onChangeStep = nextStep => {
        setStepRegistration(nextStep < 0 ? 0 : nextStep > 2 ? 2 : nextStep);
    };
    const onNext = () => onChangeStep(stepRegistration + 1);
    const onPrevious = () => onChangeStep(stepRegistration - 1);
    const steps =[
        { title : 'Informations Personnelles' , compounent : <PersonalInfos/> , highlightTitle : 'Informations Personnelles'},
        {title : 'Niveau d\'éducation' , compounent: <EducationLevel/> , highlightTitle : '' },
        {title : "Comment ?" , compounent: <Comment/> , highlightTitle: "Comment avez vous entendre de Siamois"}
    ]

    useEffect(() => {
        if(location?.state?.registration){
            console.log('Display the registration modal')
                setRegistrationModalStatus(true);
        }
    }, [location]);
    const goNextModal =()=>{
        setRegistrationModalStatus(false);
        setTimeout(()=>{
            setAbonnementModalStatus(true)
        },100)
    }
    return (
        <React.Fragment>
            <div>
                Home Page
            </div>
            {/*Modal after registration*/}
            <Modal
                className="fade bd-example-modal-lg"
                show={isRegistrationModalOpen}
                size="lg"
            >
                <Modal.Header>
                    <Modal.Title>Bienvenue au Siamois QCM !</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Steps current={stepRegistration}>
                            {steps.map(step=><Steps.Item title={step.title}/> )}
                            {/*<Steps.Item title="Informations Personnelles"  />*/}
                            {/*<Steps.Item title="Niveau d'éducation" />*/}
                            {/*<Steps.Item title="L'université" />*/}
                            {/*<Steps.Item title="Rèsidanat"  />*/}
                            {/*<Steps.Item title="Comment ?"/>*/}
                        </Steps>
                        <hr />
                        <Panel header={steps[stepRegistration].highlightTitle}>
                            {steps[stepRegistration].compounent}
                        </Panel>

                        {/*<ButtonGroup>*/}
                        {/*    <Button onClick={onPrevious} disabled={step === 0}>*/}
                        {/*        Previous*/}
                        {/*    </Button>*/}
                        {/*    <Button onClick={onNext} disabled={step === 3}>*/}
                        {/*        Next*/}
                        {/*    </Button>*/}
                        {/*</ButtonGroup>*/}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light light" onClick={onPrevious} disabled={stepRegistration === 0}>Previous</Button>
                    <Button variant="dark light ml-3" onClick={stepRegistration < 2 ?onNext : goNextModal} disabled={stepRegistration ===3}>Next</Button>
                </Modal.Footer>
            </Modal>
            {/*Modal abonnement*/}
            <Modal
                className="fade bd-example-modal-lg"
                show={isAbonnementModalOpen}
                size="lg"
            >
                <Modal.Body>
                    <div className="d-flex align-items-center flex-column flex-lg-row">
                        <div className="col-lg-6 col-12">
                            <div className="col-12">
                                <div className="abonnementPrimaryTitle text-align-center mb-2 mb-lg-0">Enjoy Siamois uninterrupted</div>
                                <div className="abonnementSubTitle">Purchase membership now to extend your access</div>
                            </div>
                            <img className="col-12" src={AbonnementPic} alt=""/>
                        </div>
                        <div className="col-lg-6 col-12 d-flex flex-column">
                            <div className="d-flex mt-2 mb-2">
                                <BookRounded className="abonnementIcon"/>
                                <div className="abonnementSubTitle">
                                    <span className="abonnementTitle">Unlimited access to the medical library</span><br/>
                                    Deepen your knowledge with hundreds of articles covering all clinical and basic science subjects
                                </div>
                            </div>
                            <div className="d-flex mt-2 mb-2">
                                <BorderColorRounded className="abonnementIcon"/>
                                <div className="abonnementSubTitle">
                                    <span className="abonnementTitle">Thousands of high-yield questions</span><br/>
                                    Simulate exams and boost your knowledge with NBME-style questions
                                </div>
                            </div>
                            <div className="d-flex mt-2 mb-2">
                                <BarChartRounded className="abonnementIcon"/>
                                <div className="abonnementSubTitle">
                                    <span className="abonnementTitle">Personalized study recommendations</span><br/>
                                    Study more efficiently. Get AI-powered learning recommendations based on your profile
                                </div>
                            </div>
                            <Button onClick={()=>history.push('/payment')} className="mt-2 mb-2" variant="primary light">Compare Memberships</Button>
                            <Button onClick={()=>setAbonnementModalStatus(false)} className="mt-2 mb-2" variant="dark light">Profiter de modules gratuits </Button>

                        </div>
                    </div>

                </Modal.Body>
            </Modal>


        </React.Fragment>

   );
};

export default Home;
